var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-conent main-conent-minheight page-rodent"},[(_vm.type === 'okq')?_c('okq'):(_vm.type === 'other')?_c('other'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }